import clsx from "clsx";
import st from "@/styles/Ui.module.scss";
import WarningIcon from "@/svg/WarningIcon.tsx";
import Button from "@/ui/Button.tsx";
import {useTranslation} from "react-i18next";
import WarningCircleIcon from "@/svg/WarningCircleIcon.tsx";
import TickIcon from "@/svg/TickIcon.tsx";
import DashboardClass from "@/utils/dashboard_class.ts";
import {useNavigate} from "react-router-dom";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import {useAtom} from "jotai";
import {profile} from "@/atoms/profile.ts";

interface Props {
    text: string
    is_phone: boolean
    status: "warning" | "danger" | "success"
    continue_kyc?: boolean
}


const StatusMessage:React.FC<Props> = (props) => {
    
    const {
        text,
        is_phone,
        status,
        continue_kyc
    } = props
    const navigate = useNavigate()
    const [user] = useAtom(profile)
    const timestamp = Number(user?.kyc.success_finished_at || "0") * 1000
    // const date: Date = new Date(timestamp);
    const now: Date = new Date();

// Format time as "YYYY-MM-DD HH:MM:SS UTC"
//     const formattedTime: string = date.toISOString().replace('T', ' ').split('.')[0] + ' UTC';

// Check if current time is less than 15 minutes after the timestamp
    const fifteenMinutesLater: number = timestamp + 15 * 60 * 1000;
    const isWithin15Minutes: boolean = now.getTime() < fifteenMinutesLater;


    const {t} = useTranslation()
    
    return (
        <>
            
            <div className={clsx(st.status_message, st[status])}>
                
                {status === "success" ? (
                    <>
                        {isWithin15Minutes ? (
                            <strong>
                                <TickIcon/> {" " +t("success_kyc")}
                            </strong>
                        ) : null}
                    </>
                ) : (
                    <span>
                        
                        {status === "danger" && (
                            <WarningIcon/>
                        )}
                        
                        {status === "warning" && (
                            <WarningCircleIcon/>
                        )}
                        
                        {" " + text}
                        
                        {!is_phone ? (
                            <strong>{t("need_phone")}</strong>
                        ) : null}
                        
                    </span>
                )}
            </div>
            
            {continue_kyc && (
                <Button className={st.new_credit_btn} onClick={() => {
                    navigate(DashboardClass.dashboard_routes.KYC)
                }}>
                    {t("got_to_kyc")}
                </Button>
            )}
            
            {!is_phone ? (
                <Button
                    className={st.new_credit_btn}
                    onClick={() => {
                        eventEmitter.emit(CommonClass.ModalEvents.SetPhone, true)
                    }}
                >
                    {t("set_phone")}
                </Button>
            ) : null}
        
        </>
    )
}

export default StatusMessage